export enum JoinFormType {
  JoinAR = 'JoinAR',
  JoinRA = 'JoinRA',
  JoinCR = 'JoinCR',
}
